import { cls } from "@wss/cls";
import React from "react";
import {
  EnrollmentOption,
  PlusModalData,
} from "~/common/PlusSubscriptionModal/Models";
import { User } from "~/common/Store/connectUserAndChat";
import PlusSignupLink from "../PlusSignupLink";
import GoogleViewPrice from "./GoogleViewPrice";
import PlusRegularPricing from "./PlusRegularPricing";
import StandardPrice from "./StandardPrice";

import(
  /* webpackChunkName: "modals-standalone" */ "~/bootstrap/less/modals-standalone.less"
);

interface Props {
  unitOfMeasure: string;
  plusMemberPrice: number;
  regularPrice: number;
  p1Price: number;
  showCrossoutPrice: boolean;
  divideByUnit?: string;
  divideQuantity?: number;
  showPlusSignup: boolean;
  user: User;
  isGoogleView?: boolean;
  minimumBuy?: number;
  mustBuy?: number;
  plusModalData?: PlusModalData;
}

const PlusPrice = ({
  unitOfMeasure,
  regularPrice,
  plusMemberPrice,
  showCrossoutPrice,
  p1Price,
  divideByUnit,
  divideQuantity,
  showPlusSignup,
  user,
  isGoogleView = false,
  minimumBuy = 1,
  mustBuy = 1,
  plusModalData,
}: Props) => {
  const divideByUnitCssClass = "text-xs block ";
  const showDivideBy = !showPlusSignup;

  return (
    <>
      <div className="plus-member plus-member-override plus-member--plus">
        <div className="plus-member__group xxxxl:flex-nowrap">
          <div
            className="plus-member__text plus-member__price"
            data-testid="regular-price-container"
          >
            <PlusRegularPricing
              unitOfMeasure={unitOfMeasure}
              regularPrice={regularPrice}
              p1Price={p1Price}
              showCrossoutPrice={showCrossoutPrice}
              divideByUnit={divideByUnit}
              divideQuantity={divideQuantity}
              isGoogleView={isGoogleView}
              minimumBuy={minimumBuy}
              mustBuy={mustBuy}
              divideByUnitCssClass={divideByUnitCssClass}
            />
          </div>
          <div
            className="plus-member__price plus-member__price--plus-member flex justify-center flex-col"
            data-testid="plus-price-container"
          >
            <label className={cls("price__label", showCrossoutPrice && "py-1")}>
              <span className="plus-flag">Plus</span> Member Price{" "}
            </label>
            {isGoogleView ? (
              <GoogleViewPrice
                price={plusMemberPrice}
                unitOfMeasure={unitOfMeasure}
                showCreditKey={false}
                divideByUnit={showDivideBy ? divideByUnit : ""}
                divideQuantity={showDivideBy ? divideQuantity : undefined}
                divideByUnitCssClass={divideByUnitCssClass}
                minimumBuy={minimumBuy}
                mustBuy={mustBuy}
              />
            ) : (
              <StandardPrice
                price={plusMemberPrice}
                unitOfMeasure={unitOfMeasure}
                showCreditKey={false}
                divideByUnit={showDivideBy ? divideByUnit : ""}
                divideQuantity={showDivideBy ? divideQuantity : undefined}
                divideByUnitCssClass={divideByUnitCssClass}
              />
            )}
            {showPlusSignup && (
              <PlusSignupLink plusModalData={plusModalData} user={user} />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default PlusPrice;
